import { createGlobalState } from 'react-hooks-global-state'

// we need this to be global so that navigation changes doesn't rid the chosen venue
const globalSelectedVenueState = createGlobalState({
  selectedVenueId: '',
})

export default globalSelectedVenueState
